import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Picture from '../Picture';

const Block = ({ title, text, image, link, wasVisible, willBeVisible }) => (
  <div
    className={cx('block', {
      'was-visible': wasVisible,
      'will-be-visible': willBeVisible,
    })}
  >
    <h4>{title}</h4>
    {image ? <Picture {...image} /> : null}
    <p>{text}</p>
    {link ? (
      <a href="{link.url}" target="_blank">
        {link.text}
      </a>
    ) : null}
  </div>
);

Block.propTypes = {
  image: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  text: PropTypes.string.isRequired,
  title: PropTypes.string,
  wasVisible: PropTypes.bool,
  willBeVisible: PropTypes.bool,
};

Block.defaultProps = {
  image: null,
  link: null,
  title: null,
  wasVisible: false,
  willBeVisible: false,
};

export default Block;



// WEBPACK FOOTER //
// ./src/components/Blocks/block.js